export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.userId = payload.userId;
    state.didAutoLogout = false;
  },
  setPosts(state, payload) {
    state.postsdata = payload;
  },
  updatePosts(state, payload) {
    //게시글 삭제후 해당값 삭제
    if(state.postsdata.data)
    {
      const findItem = state.postsdata.data.find((post)=>post.id === payload);
      const idx = state.postsdata.data.indexOf(findItem);
      state.postsdata.data.splice(idx,1);
    }
  },
 
  setCurrentPage(state, payload) {
    state.postsdata.current_page = payload;
  },
  setViewPost(state, payload) {
    state.viewpost = payload.post;
  },
  updateCount(state, payload){
    if(state.postsdata.data)
    {
      state.postsdata.data.find((post)=>post.id === payload.id).count=payload.count
    }
  },
  updateRecommend(state, payload){
    let r = state.postsdata.data.find((post)=>post.id === payload.post.id)
    r.recommend = payload.post.recommend
    //recommends데이터 있으면 제거, 없으면 push
    if(r.recommends.length > 0)
    {     
      r.recommends=[]
      state.viewpost.recommends=[]
    }else{     
      r.recommends.push(payload.recommends)
      state.viewpost.recommend++
      state.viewpost.recommends.push(payload.recommends)
    }
    //현재 뷰포스트도 업데이트
    

    
  },  
};
